import GlobalSearch from '@/components/GlobalSearch';
import KeyboardShortcutsDialog from '@/components/KeyboardShortcutsDialog';
import { useGlobalHotkeys } from '@/hooks/useAppHotkeys';
import { HotkeysProvider } from '@tanstack/react-hotkeys';
import { FunctionComponent, PropsWithChildren, useCallback, useState } from 'react';

/**
 * Inner component that registers hotkeys.
 * Must be rendered inside <HotkeysProvider>.
 */
const HotkeyRegistrar: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [shortcutsDialogOpen, setShortcutsDialogOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  const handleOpenShortcuts = useCallback(() => {
    setShortcutsDialogOpen(true);
  }, []);

  const handleOpenSearch = useCallback(() => {
    setSearchOpen(true);
  }, []);

  // Register global hotkeys (always active)
  useGlobalHotkeys(handleOpenShortcuts, handleOpenSearch);

  return (
    <>
      {children}
      <KeyboardShortcutsDialog open={shortcutsDialogOpen} onOpenChange={setShortcutsDialogOpen} />
      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
    </>
  );
};

/**
 * Top-level provider that wraps the app with TanStack HotkeysProvider
 * and registers all global/project keyboard shortcuts.
 */
const HotkeyProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <HotkeysProvider>
      <HotkeyRegistrar>{children}</HotkeyRegistrar>
    </HotkeysProvider>
  );
};

export default HotkeyProvider;
